import { TransactionEntryFieldsFragment } from '../graphql/generated';

export const sampleTransactionEntries: TransactionEntryFieldsFragment[] = [
    {
        id: '652241f1-9718-4ae3-b8c0-1e84eb33e0bc',
        name: 'POS DEBIT OAKLAND PARK METER IPS',
        amount: -125,
        date: '2024-02-27',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: '305064e5-fcb0-442f-a0d1-8c3a5b1f518d',
        merchant: {
            id: 'b860c95f-feea-45d3-8ecc-502ee8d42b52',
            name: 'Oakland Park Meter Ips',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '06017724-cf7b-4463-a6ad-aba706016316',
        name: 'MISFITS MARKET',
        amount: -7565,
        date: '2024-02-26',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '03e796b6-2432-46b4-8f3d-428db08afdd1',
            name: 'Misfits Market',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0a9f9828-45ea-44d2-bb48-b7cf177fe0e2',
        name: "Trader Joe's",
        amount: -2138,
        date: '2024-02-26',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'dad836a8-06ad-429d-9063-a840d2c85505',
            name: "Trader Joe's",
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/trader_joes_1041.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '15fdd879-eb57-47db-89a9-06bc1d2834b2',
        name: 'POPPY BAGELS',
        amount: -3575,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:30+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '8298ffa1-d134-47df-a983-81c36f674445',
            name: 'Poppy Bagels',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '3a01a38b-4293-4afd-b47e-c741df01a0b0',
        name: 'DBA MICHAEL RAPPAPORT',
        amount: -1400,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:31+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: '614b3d1f-ded7-4c0d-8958-7f9d9d50256a',
            name: 'Dba Michael Rap',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '3d8d27eb-7919-4186-9622-2bc45a67459e',
        name: 'Payment to Chase card ending in 8454 02/26',
        amount: -606626,
        date: '2024-02-26',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
        merchant: null,
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '3efe375a-0ee0-4280-be38-120f88798ce1',
        name: "TST* JENI'S SPLENDID ICE",
        amount: -852,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:33+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'b86bb7c7-1673-4a73-b25e-4435002d8fac',
            name: "Jeni's Splendid Ice",
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5133b5fa-1364-4cb0-9a86-a58c5640455c',
        name: 'Venmo',
        amount: -6000,
        date: '2024-02-26',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
        merchant: null,
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '601df633-f3d2-4612-b422-91b0002642ac',
        name: 'OAKLAND PARKS & REC',
        amount: -500,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:27+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: '12559217-f2bc-4442-bd9d-2cadbd340f48',
            name: 'Oakland Parks & Rec',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '60734c57-f44e-40e3-b8bf-81569edf34d6',
        name: 'Kindle Svcs*RZ5FF5PW0',
        amount: -499,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:28+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '9d9c2725-41fe-4623-9b6c-7f9e29b4606e',
        merchant: {
            id: '0541f1ee-fa94-4752-99e5-dcdd3add5065',
            name: 'Amazon Kindle',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/amazon_kindle_46.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6a7169d9-50e8-4f00-9f34-9dfa5d55d38a',
        name: 'Payment Thank You - Web',
        amount: 606626,
        date: '2024-02-26',
        dateTime: '2024-02-26T21:12:15+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '543158d2-9e62-4394-97bb-922f1ab64e34',
        merchant: null,
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '75f0b25b-7f4c-4525-bb4c-425eb6ff6a39',
        name: 'Whole Foods',
        amount: -1909,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:26+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '42dfa01e-6fcc-4b61-9739-1ac1ae3278dc',
            name: 'Whole Foods',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/whole_foods_1122.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '880da4c6-7d8c-45e8-9f33-89ebfde0e3dc',
        name: 'SJ BERRIES',
        amount: -800,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:35+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'aeb6e684-97af-41d9-b99c-ea944c49b39d',
            name: 'Sj Berries',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8ccd899b-b412-4359-8f8a-d3d5cda02e14',
        name: 'FLATBREAD QUEEN, INC.',
        amount: -900,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:34+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'e9fff2f6-0f0e-403c-83a9-f9a46d295548',
            name: 'Flatbread Queen',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '930c4643-0ee5-47e7-b509-56978ebb5b8f',
        name: 'E&H FARMS',
        amount: -650,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:25+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '01f50656-5184-4780-a0fd-bad53de7979d',
            name: 'E&h Farms',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a54a9c35-b416-4bd1-91fb-62c8a1c9a099',
        name: 'UNLIMITED COMPANY LLC',
        amount: -1400,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:32+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'e87726b2-77b4-4f84-91d2-921586b3ad0e',
            name: 'Unlimited Company LLC',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c802b61b-acbb-4a8f-8cef-2a706afc6e81',
        name: 'TST* LITTLE BROTHER - SOC',
        amount: -775,
        date: '2024-02-26',
        dateTime: '2024-02-26T18:05:29+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '08bdf8ef-dd62-4628-bc69-47bd99190ed0',
            name: 'Little Brother',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e1866b07-ac96-4f04-8193-c164fc6cbf24',
        name: 'MARKET HALL BAKERY',
        amount: -350,
        date: '2024-02-26',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f62bcf34-f76f-489f-8e21-33802f77ad56',
        name: 'Hulu',
        amount: -1799,
        date: '2024-02-26',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: '8813b8c2-cfa6-4c39-afc5-21d0e9f785ec',
        merchant: {
            id: 'e1f285e7-d2f3-492f-b303-dc383db5c32d',
            name: 'Hulu',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/hulu_504.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '2d3c19a4-1386-4a1d-b87d-a791144da11f',
        name: 'Amazon',
        amount: -2170,
        date: '2024-02-25',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '348242bd-4380-43bc-8e50-c15bee4027d2',
        name: 'Learning Express',
        amount: -3353,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:18+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '2dd81800-15f4-4837-91c7-5fa298c25219',
            name: 'Learning Express Toys',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '34d4ce64-878a-4377-a5a3-719b97ac27b8',
        name: "Trader Joe's",
        amount: -3222,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:09+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'dad836a8-06ad-429d-9063-a840d2c85505',
            name: "Trader Joe's",
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/trader_joes_1041.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '42b85458-11bf-4a36-9f57-460d576bc246',
        name: 'COLE HARDWARE',
        amount: -1101,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:04+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '087ba921-22a6-4f08-a690-5d5965e8ad31',
        merchant: {
            id: '09ec5462-8b89-4fd5-87df-b8e28db88107',
            name: 'Cole Hardware',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '46711d17-0a67-4d7f-bbb3-baae13e93595',
        name: 'COOKIE RICH',
        amount: -2247,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:11+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'ac9a89f9-ef28-4210-84cf-fbea3c5985e4',
            name: 'Cookie Rich',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '4e41b2cc-a292-475c-9f4a-eb42f3820550',
        name: 'BEATPORT',
        amount: -3596,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:15+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: '99410839-9165-4180-b3b0-1c9f4dedb644',
            name: 'Beatport',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5e4a90dc-388c-41b8-aee7-3cc28913697c',
        name: 'DD DOORDASH ARTEMISME',
        amount: -3272,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:07+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'a8cdad08-c865-4ad2-b4a1-5b62c99580b8',
            name: 'Artemisme',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '7dba5bd4-6ca2-45e8-996f-1ac4fe44b1f6',
        name: 'TST* STARTER BAKER',
        amount: -2500,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:10+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'd202a87b-9b6e-4b7f-9a0e-9a8a03e4d387',
            name: 'Starter Baker',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '94201833-df7c-44ad-9005-fca33d322f5a',
        name: 'TST* FRONT YARD BREWING -',
        amount: -4286,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:05+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'd45ad768-9299-44d8-9546-36466c5dc485',
            name: 'Front Yard Brewing',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'adf3dde4-1d82-450e-a44b-14ed9ab59731',
        name: 'RUNAWAY LUNA LIFESTYL',
        amount: -4691,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:14+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '4a4c2ead-3e00-4e1f-9ad6-0c4196e31d8f',
        merchant: {
            id: '810d522c-2707-4a8d-825c-ccee6656f656',
            name: 'Runaway Luna Lifestyl',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c15c532d-0b1c-41f6-bda6-71f31cafbf16',
        name: 'PREMIUM PARKING',
        amount: -2647,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:06+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '305064e5-fcb0-442f-a0d1-8c3a5b1f518d',
        merchant: {
            id: 'ddf50b9f-559c-4570-9053-9651146e1f57',
            name: 'Premium Parking',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e4e516c4-69b1-4b7f-bf2c-1730093d9efb',
        name: 'CRAZY BLOCK CHEESECAK',
        amount: -900,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:16+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'a50fc46a-bda9-4070-98a8-484c7d597353',
            name: 'Crazy Block Cheesecak',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e5476a16-af82-4764-a4be-c60f7ba39b80',
        name: 'ALMANAC BEER CO.',
        amount: -1063,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:08+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '21647f9f-7198-47af-b382-509117fdc5e1',
            name: 'Almanac Beer Co.',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ecbb1b94-bd6c-412c-b133-b8b40bf93fad',
        name: 'YOGURT PLANET',
        amount: -597,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:03+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'd5cb7976-8d25-4d1a-916f-6b1d0a29773a',
            name: 'Yogurt Planet',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f2bc871d-105b-4803-b875-c5689bd43cc3',
        name: 'CACTUS TAQUERIA',
        amount: -3864,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:17+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '4b37b468-2d22-4b86-8d07-a47cbd0d839b',
            name: 'Cactus Taqueria',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'fd1d62bc-cd6c-4f26-a202-3f786bd6b637',
        name: 'CLIPPER SERVICES',
        amount: -3000,
        date: '2024-02-25',
        dateTime: '2024-02-25T14:11:13+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'f9242742-aeca-4c3f-a7b4-89dd0f2bfe21',
        merchant: {
            id: 'c24df4ea-6fbb-4a2a-a59e-d4025459a71d',
            name: 'Clipper Service',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ff8e2e26-f1e1-4bf3-b563-c1ba5a93bb77',
        name: 'RERACK',
        amount: -1600,
        date: '2024-02-25',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
        merchant: {
            id: 'd02f2ea7-0fe7-4351-94e5-39c0b78e192f',
            name: 'Rerack',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c7dd3e55-d163-4a12-af10-8e5f64819bab',
        name: 'Feb 2024 Dividends',
        amount: 52,
        date: '2024-02-24',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a68f44ca-cd4c-4d1c-8b3c-e80f04f23410',
        merchant: {
            id: '9a7435ba-1f7a-41e3-ace7-87ab48a83587',
            name: 'Plenty',
            logoUrl:
                'https://mnv45gni8p6522bf.public.blob.vercel-storage.com/plenty_logo_square-u76akmIb2ewPDSSraiXO3Y4XSFWUWS.png',
            __typename: 'Merchant',
        },
        financialEntityId: 'eca91587-d12b-4091-9d11-3f03ee2f17d7',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '1ce2c770-3e28-4beb-9794-a2f0fb143197',
        name: 'OAK ESSENTIALS SST',
        amount: -379,
        date: '2024-02-23',
        dateTime: '2024-02-23T16:47:05+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'a5de3052-84cb-4067-953e-64ecd8daa4f2',
            name: 'Oak Essentials Sst',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '2a060b03-2a36-48de-a0bb-211f99834442',
        name: 'Lyft',
        amount: -3999,
        date: '2024-02-23',
        dateTime: '2024-02-23T16:47:04+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '44395cad-1f92-4a23-93eb-89862e433b55',
        merchant: {
            id: '2fb970d1-b79b-4ed9-97c0-126a250273a6',
            name: 'Lyft',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/lyft_597.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '981c4aac-4964-4632-988c-23d96db2587d',
        name: 'TST* TAY HO - OAKLAND AIR',
        amount: -1902,
        date: '2024-02-23',
        dateTime: '2024-02-23T16:47:03+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '1f8a2d7d-5171-4591-a891-817a2ede2038',
            name: 'Tay Ho',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '39a6373e-6744-4cca-a820-8bcde054f8ac',
        name: 'nuuly.com',
        amount: -10805,
        date: '2024-02-22',
        dateTime: '2024-02-22T18:05:57+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: 'b0045be7-a975-4cea-a7d7-e66b5dd24689',
            name: 'Nuuly',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/nuuly_1486.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '3d459249-8423-4577-9af5-b2db7a1e7293',
        name: 'OAKLANDNEWSST2663',
        amount: -440,
        date: '2024-02-22',
        dateTime: '2024-02-22T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '9d9c2725-41fe-4623-9b6c-7f9e29b4606e',
        merchant: {
            id: 'e3dae7ca-2c81-412f-9b18-12ce60505666',
            name: 'Oaklandnewsst',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '66ede066-20bf-42b3-b7ac-612e3efec6e4',
        name: 'MARKET HALL BAKERY',
        amount: -3300,
        date: '2024-02-22',
        dateTime: '2024-02-22T18:05:59+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '7f691b1f-63dd-4a35-bc06-0bcd3e31011c',
        name: 'Lyft',
        amount: -2585,
        date: '2024-02-22',
        dateTime: '2024-02-22T18:05:56+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '44395cad-1f92-4a23-93eb-89862e433b55',
        merchant: {
            id: '2fb970d1-b79b-4ed9-97c0-126a250273a6',
            name: 'Lyft',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/lyft_597.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a6ac21b2-f2ed-442c-85ff-321bd0f819ee',
        name: 'Walgreens',
        amount: -126,
        date: '2024-02-22',
        dateTime: '2024-02-22T18:05:55+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '14fa2957-f171-4036-b7fc-bc45c70856b0',
        merchant: {
            id: '7be0356b-0422-4a30-9f38-a95d3455d689',
            name: 'Walgreens',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/walgreens_1099.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'caddfc82-99bb-4060-81a2-2ae0d4f963f7',
        name: 'KINGBOB.',
        amount: -1189,
        date: '2024-02-22',
        dateTime: '2024-02-22T18:05:54+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'f2512a3b-bdfb-4c01-8a04-a3276e4f4e4e',
            name: 'Kingbob.',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'dfdaa493-6ce9-47cf-8362-25921720e893',
        name: 'Walmart',
        amount: -2684,
        date: '2024-02-22',
        dateTime: '2024-02-22T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '2246a9ea-7454-435f-809e-97734649bfeb',
            name: 'Walmart',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/walmart_1100.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e3acb6c8-636d-4ac0-84c1-c654fd2a9807',
        name: 'CARBON HEALTH',
        amount: -5500,
        date: '2024-02-22',
        dateTime: '2024-02-22T18:05:58+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '80425c56-dd6d-4762-b140-46c1a8cf713e',
        merchant: {
            id: '1300e9e7-5d55-41e9-be0c-a2c887d528bc',
            name: 'Carbon Health',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '072b8f8a-774c-4216-b609-81e730885ff8',
        name: 'MARKET HALL PRODUCE',
        amount: -2643,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:35+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '09885ca7-d496-4e3b-9d48-02034b3a198c',
        name: 'OAKLAND PARK METER IPS',
        amount: -325,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:39+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '305064e5-fcb0-442f-a0d1-8c3a5b1f518d',
        merchant: {
            id: 'aa027314-6825-4da1-8127-a6ffe149ad16',
            name: 'Park Meter Ips',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '185ddc5a-9028-4562-b146-dafb9796bccf',
        name: 'LAVENDER NAIL SPA',
        amount: -3000,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:33+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '4a4c2ead-3e00-4e1f-9ad6-0c4196e31d8f',
        merchant: {
            id: '6767e335-2c58-4614-be34-a887c75a3d5b',
            name: 'Lavender Nail Spa',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '2d6360b9-e815-417d-8455-d38beea5608d',
        name: 'SP BELLAVITA',
        amount: -3749,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:40+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: 'f45d5aee-714e-48af-bbf4-f4dd2d176d3d',
            name: 'Bellavita',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '47757b2a-90c4-4ec6-80f3-229d894306ed',
        name: 'PERSHING BROKERAGE PPD ID: 1132741729',
        amount: 50000,
        date: '2024-02-21',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ca9f953c-a612-493f-8dfe-6a3e94b48117',
        merchant: {
            id: '1e414ac7-e9c9-4a39-a04c-950bc60342e1',
            name: 'Pershing',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: 'f25d9ef5-72af-4188-9bec-78dd2530de59',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '555dbf0a-c291-4ac6-b574-0ef7d890d7af',
        name: 'INTEREST PAYMENT',
        amount: 34,
        date: '2024-02-21',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a68f44ca-cd4c-4d1c-8b3c-e80f04f23410',
        merchant: null,
        financialEntityId: 'f25d9ef5-72af-4188-9bec-78dd2530de59',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '7c03f106-793c-4576-8a3e-81195bd37327',
        name: 'COLE HARDWARE',
        amount: -1800,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:36+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '087ba921-22a6-4f08-a690-5d5965e8ad31',
        merchant: {
            id: '09ec5462-8b89-4fd5-87df-b8e28db88107',
            name: 'Cole Hardware',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '874be32b-496d-4440-9d28-bfd1c9d6c170',
        name: 'CHECK # 338',
        amount: -39000,
        date: '2024-02-21',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '9336dab5-69ef-4bc8-a1d8-9d902a3fb426',
        merchant: {
            id: 'f828c390-d7c1-4b29-9d51-bf6a0e7b291f',
            name: 'Four Dimensions Landscape',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'baff086d-583f-4b86-8770-58279c08cac0',
        name: 'HIGHWIRE COFFEE ROAST',
        amount: -2875,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:37+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: '1fed88f6-248c-4813-b6e1-e85b2192f45e',
            name: 'Highwire Coffee Roast',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c282ec7c-7619-4106-9cc3-bfd003afb43f',
        name: 'DEPT EDUCATION STUDENT LN PPD ID: 9102001001',
        amount: -14078,
        date: '2024-02-21',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'da9d599f-0658-4d4b-81da-083d40d2d9cc',
        merchant: {
            id: '2897107e-fa71-4651-a7cc-39dfa7932086',
            name: 'Dept Education Student Ln',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c7327d18-5685-4af4-9a2c-ba8a81a1e841',
        name: 'WWW.ROCKRIDGEROYALCLEA',
        amount: -2070,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:38+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: 'd4bedc4a-384f-415e-ab15-18657edfce77',
            name: 'Rockridgeroyalclea',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ef5cccf1-4437-4739-842a-ab5022afd8b6',
        name: 'Spotify',
        amount: -1699,
        date: '2024-02-21',
        dateTime: '2024-02-21T16:10:34+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: '7a1d3433-c3b8-45f7-82ec-8cd395a38519',
            name: 'Spotify',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/spotify_947.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '13c99398-e2b2-443f-8323-e1038143af68',
        name: 'RUSSAMEE TRADITIONAL THA',
        amount: -5000,
        date: '2024-02-20',
        dateTime: '2024-02-20T16:23:04+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '9336dab5-69ef-4bc8-a1d8-9d902a3fb426',
        merchant: {
            id: '6110606b-0a27-4582-b065-c4b1d5d1e03e',
            name: 'Russamee Traditional Thai',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '3e2fb4a5-c987-4a82-8d4e-594eb15f0f76',
        name: 'Plenty Goal Deposit',
        amount: 1000000,
        date: '2024-02-01',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '8fdb2f06-a1f0-4f77-90c1-9be3287913a2',
        merchant: {
            id: '9a7435ba-1f7a-41e3-ace7-87ab48a83587',
            name: 'Plenty',
            logoUrl:
                'https://mnv45gni8p6522bf.public.blob.vercel-storage.com/plenty_logo_square-u76akmIb2ewPDSSraiXO3Y4XSFWUWS.png',
            __typename: 'Merchant',
        },
        financialEntityId: '4fc8a80a-e466-4f4d-adb9-faa1ff9ba871',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '62c4c26e-3e1d-4251-add0-51061afb7132',
        name: 'PAYPAL INST XFER APPLE.COM BILL WEB ID: PAYPALSI77',
        amount: -299,
        date: '2024-02-20',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '323f28a1-755d-479d-9fc6-96731b7d339a',
            name: 'Apple',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/apple_63.png',
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '79342f6d-a658-461e-be2a-e537fe013a15',
        name: "Trader Joe's",
        amount: -10699,
        date: '2024-02-20',
        dateTime: '2024-02-20T16:23:06+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'dad836a8-06ad-429d-9063-a840d2c85505',
            name: "Trader Joe's",
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/trader_joes_1041.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'bba278e9-130c-4e18-ae2d-30826aab3588',
        name: 'SEED.COM',
        amount: -5511,
        date: '2024-02-20',
        dateTime: '2024-02-20T16:23:05+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '4a4c2ead-3e00-4e1f-9ad6-0c4196e31d8f',
        merchant: {
            id: 'ee9c95f7-bde6-44e8-9326-c31afb9bd299',
            name: 'Seed',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd827f63b-60d4-4537-a409-b0771ba54b1b',
        name: 'LE BOULANGER',
        amount: -1169,
        date: '2024-02-20',
        dateTime: '2024-02-20T16:23:07+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '1ed00b35-d73e-429d-be99-f9ffd1b02b02',
            name: 'Le Boulanger',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '03978079-8d93-46c6-93eb-335558706f31',
        name: 'THE MIDWIFE AND THE B',
        amount: -400,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:41+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'd09f64cb-98bd-4037-a0da-d1411988dfa7',
            name: 'The Midwife And The',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '12d8d564-aee3-47eb-951c-1f9b5e878afd',
        name: 'BROC CELLARS',
        amount: -5600,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:42+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'b7f38864-690a-4b50-9da2-33271f41db32',
            name: 'Broc Cellars',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '21d4147c-c162-4de7-8ddb-49afb5ad123a',
        name: 'UNLIMITED COMPANY LLC',
        amount: -500,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:35+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: 'e87726b2-77b4-4f84-91d2-921586b3ad0e',
            name: 'Unlimited Company LLC',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '37e31c58-8a65-42c3-90f3-87ae15f521cf',
        name: 'TRUMER TAPROOM',
        amount: -3608,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:33+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'b5804fb5-fa37-4253-9fa6-9a34a8232914',
            name: 'Trumer Taproom',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '533387f7-5d0e-4db8-b9ca-6e0b3356e9c5',
        name: 'SJ BERRIES',
        amount: -800,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:39+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'aeb6e684-97af-41d9-b99c-ea944c49b39d',
            name: 'Sj Berries',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8e6a0302-125a-4b7c-af8b-81452cba2d03',
        name: 'CAFE REVEILLE',
        amount: -1175,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:43+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: 'cd8118ac-1e50-49d0-8a60-c60721e01297',
            name: 'Cafe Reveille',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '95490d11-d5ec-4f0a-b876-94da3e638400',
        name: 'BROC CELLARS',
        amount: -3075,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:34+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'b7f38864-690a-4b50-9da2-33271f41db32',
            name: 'Broc Cellars',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd3451283-eb9b-4e08-9d6f-73a300cde43f',
        name: 'BROC CELLARS',
        amount: -3608,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:37+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'b7f38864-690a-4b50-9da2-33271f41db32',
            name: 'Broc Cellars',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'db4bb234-028f-488a-be9e-3b0cb8b0eaae',
        name: 'RHETORIC OUTSIDE LLC',
        amount: -575,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:40+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'fb4d11ff-8bcd-4ce6-950a-8fd053afe825',
            name: 'Rhetoric Outside LLC',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ed717880-7198-459c-a7a0-81695f4a766e',
        name: 'MARKET HALL PRODUCE',
        amount: -1460,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:38+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ee98746c-83b2-4a01-88b2-7ffa7542bcc5',
        name: 'TRUMER TAPROOM',
        amount: -782,
        date: '2024-02-19',
        dateTime: '2024-02-19T16:42:36+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'b5804fb5-fa37-4253-9fa6-9a34a8232914',
            name: 'Trumer Taproom',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0785eef7-6bf7-4836-bee8-dc5c32bf0d3d',
        name: 'Target',
        amount: -8268,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:25+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: 'dfb3bef1-d020-4907-a084-bb084899b19a',
            name: 'Target',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/target_997.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '2626860f-e515-4b26-8c51-9344b11f549b',
        name: 'Amazon.com*RW49Q24N0',
        amount: -4497,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:31+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '2f0412c8-281c-4bf2-bbc0-8c5884baecb1',
        name: 'Amazon.com*RI5B274L1',
        amount: -3308,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:42+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '35fd0413-2cbd-4fbf-aa78-bf9363fac26d',
        name: 'TST* CELLARMAKER - BERKEL',
        amount: -1042,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:37+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '72eabaae-5b81-483b-b9ce-a3430738bc65',
            name: 'Cellarmaker',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '53b4f04a-125c-4489-85ca-2a0ba674fca0',
        name: 'Netflix',
        amount: -2348,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:36+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '8813b8c2-cfa6-4c39-afc5-21d0e9f785ec',
        merchant: {
            id: '0221ff4f-eedf-4e5a-9e95-b875d642aeef',
            name: 'Netflix',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/netflix_675.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '58552bb1-763f-4c9b-9a8e-15f91f993208',
        name: 'APPLE.COM/BILL',
        amount: -999,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:27+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '323f28a1-755d-479d-9fc6-96731b7d339a',
            name: 'Apple',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/apple_63.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6a026357-4c6e-4c04-baf8-0c8cff1e1826',
        name: 'HAPUKU FISH SHOP',
        amount: -1250,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:41+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'e20d8a35-e542-492e-8945-825328c11501',
            name: 'Hapuku Fish Shop',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6dd1b966-6d31-4675-950e-cb48089382ab',
        name: 'MARKET HALL BAKERY',
        amount: -1150,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:33+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '795f5e12-afec-4cf7-a5bb-0b0b6d213d36',
        name: 'ARIZMENDI COOPERATIVE',
        amount: -1050,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:38+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'ac4306fe-0d07-47b3-ab04-e80d37adf715',
            name: 'Arizmendi Cooperative',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '863423f8-78e9-46b0-81c6-b74b8aead6da',
        name: 'WWW.ROCKRIDGEROYALCLEA',
        amount: -1030,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:43+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: 'd4bedc4a-384f-415e-ab15-18657edfce77',
            name: 'Rockridgeroyalclea',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8e7f8181-efaf-4fea-916d-d4d752aaaada',
        name: "AIN'T NORMAL",
        amount: -500,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:40+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '542581be-8769-43c3-b2fe-3b1ea39aeda1',
            name: "Ain't Normal",
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '99985932-c775-4768-8d12-f6b78859dc02',
        name: 'SONIC.NET',
        amount: -4999,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:29+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'cf4709af-fcea-4099-9eab-230d08323c0b',
        merchant: {
            id: 'fb122bf9-d195-4d78-9da8-b442db91369c',
            name: 'Sonic Internet',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c2693cf3-c704-4f50-bb35-0abcc0b09c04',
        name: 'HIGHWIRE COFFEE ROAST',
        amount: -1125,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:35+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: '1fed88f6-248c-4813-b6e1-e85b2192f45e',
            name: 'Highwire Coffee Roast',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'dd182577-b6a7-4399-b508-3edb39c0b376',
        name: 'Prime Video *RI8HI93G1',
        amount: -599,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:32+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '8813b8c2-cfa6-4c39-afc5-21d0e9f785ec',
        merchant: {
            id: '7028d073-5d61-45ac-af68-445275b94f95',
            name: 'Amazon Prime Video',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/amazon_prime_video_47.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e9600ee1-8b2b-46c5-849b-6d67c70c541f',
        name: 'OAKLAND PARK METER IPS',
        amount: -400,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:26+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '305064e5-fcb0-442f-a0d1-8c3a5b1f518d',
        merchant: {
            id: 'aa027314-6825-4da1-8127-a6ffe149ad16',
            name: 'Park Meter Ips',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'fec62954-5cfe-473b-9b99-ecfb31b79e02',
        name: 'Amazon.com*RW5677L20',
        amount: -2916,
        date: '2024-02-18',
        dateTime: '2024-02-18T17:18:28+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0cbbfda8-876d-47b2-903e-91b567271ed8',
        name: 'BAMBINO THRIFT SHOP',
        amount: -2756,
        date: '2024-02-16',
        dateTime: '2024-02-16T16:39:55+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '35f29456-16ae-43e8-9568-6f37ef5c6988',
            name: 'Bambino Thrift Shop',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5d9047d0-f666-4fb3-9f72-00555a1be911',
        name: 'SQUARESPACE INC.',
        amount: -2000,
        date: '2024-02-16',
        dateTime: '2024-02-16T16:39:56+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a78521de-510c-4b67-9271-c0a294a2a6f4',
        merchant: {
            id: '0c48b404-11e8-4290-a503-978f1c2492a2',
            name: 'Squarespace',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/squarespace_953.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '66f1fc77-debe-496c-b681-7e769401a91c',
        name: 'MARICA OAKLAND',
        amount: -5448,
        date: '2024-02-16',
        dateTime: '2024-02-16T16:39:57+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'a605735e-e522-4c98-9604-671d15e02453',
            name: 'Marica Oakland',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '147100f4-38b5-41f2-9a12-cb88c23c46fc',
        name: 'SEES CANDY 0579',
        amount: -3300,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:23+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'b23e13a2-4baf-4e6f-a96c-bf367e8c74a0',
            name: 'Sees Candy',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '16918e0b-7858-406f-a152-1e3b0f0804f9',
        name: 'PAYROLL PPD ID: 9117571000',
        amount: 297034,
        date: '2024-02-29',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: '52ecc268-7869-49d6-a266-fc38eb71c7ac',
        merchant: {
            id: '5a55fbdf-e02f-4241-9f10-7683103544d3',
            name: 'Payroll',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: 'becef62e-59c6-403f-94f1-2211e0a89107',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'fbe62cd6-3381-4152-b243-bf986614ba4f',
        name: 'PAYROLL PPD ID: 9117571000',
        amount: 210492,
        date: '2024-02-29',
        dateTime: null,
        isPending: true,
        isHidden: false,
        deletedAt: null,
        categoryId: '52ecc268-7869-49d6-a266-fc38eb71c7ac',
        merchant: {
            id: '5a55fbdf-e02f-4241-9f10-7683103544d3',
            name: 'Payroll',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '2e3231cd-172f-4db8-922b-22b0d539b262',
        name: 'PAYROLL PPD ID: 9117571000',
        amount: 210492,
        date: '2024-02-15',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '52ecc268-7869-49d6-a266-fc38eb71c7ac',
        merchant: {
            id: '5a55fbdf-e02f-4241-9f10-7683103544d3',
            name: 'Payroll',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '3a84ce82-1b58-4f88-b150-d17261b07f00',
        name: "AIN'T NORMAL",
        amount: -950,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:22+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '542581be-8769-43c3-b2fe-3b1ea39aeda1',
            name: "Ain't Normal",
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '49770112-6aad-41b0-ba9f-a2fa57de24b7',
        name: 'MARKET HALL PRODUCE',
        amount: -443,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:20+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a2f29297-e5dc-46a6-aebd-ea6e02f7cf30',
        name: 'MARKET HALL FOODS - O',
        amount: -1495,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:26+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'b96f1ccc-7cbd-49db-87f0-54b515c94513',
        name: 'MARKET HALL PRODUCE',
        amount: -3303,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:24+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c706d67a-2801-472c-8313-602055d398ce',
        name: 'TST* PROPER FOOD - 655',
        amount: -1612,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:21+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'a67dcf87-1f0a-4251-8145-8cfe33edb859',
            name: 'Proper Food',
            logoUrl: '',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd1bd92c8-99f8-4a61-bb3e-868378d1f3a3',
        name: 'MARKET HALL BAKERY',
        amount: -1040,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:25+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'df8f17e6-4e6b-4aa8-9d73-9ee0ddf12df1',
        name: 'PAUL MARCUS WINES',
        amount: -6284,
        date: '2024-02-15',
        dateTime: '2024-02-15T18:07:27+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '1363787d-ffe0-4d3b-9e61-55485c337f4b',
            name: 'Paul Marcus Wines',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '35f3c0cd-3b5f-4c4d-9b4a-721ca8c1cbda',
        name: 'Pegasus Books 3',
        amount: -435,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:22+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '9d9c2725-41fe-4623-9b6c-7f9e29b4606e',
        merchant: {
            id: 'ebe98573-49e2-4703-8401-576f38a5d54b',
            name: 'Pegasus Books',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '4a4a83b9-0102-4d05-951f-f8cc72f00b3d',
        name: 'OBE FITNESS',
        amount: -2499,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:18+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '47dcb5ea-bf36-4340-99e5-2e59adf42ff2',
        merchant: {
            id: 'a7d53852-9d93-49de-912a-e629e92788a5',
            name: 'Obe Fitness',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '4ee5a5c1-6fa2-4c99-8381-a77438cf475d',
        name: 'FISHER BREW',
        amount: -650,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:20+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: 'b5cb8298-ca53-489c-9b54-1ed3dee9662f',
            name: 'Fisher Brew',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '4f746b8a-33f8-4886-a83c-1fac623170cf',
        name: "Trader Joe's",
        amount: -2677,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:10+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'dad836a8-06ad-429d-9063-a840d2c85505',
            name: "Trader Joe's",
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/trader_joes_1041.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '55cc3b1a-ddea-4d38-b607-73f6c5f45694',
        name: 'MARKET HALL PRODUCE',
        amount: -3259,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:11+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '698bf149-d9b0-4019-9018-a49d6107300c',
        name: 'WOODLANDS MARKETS',
        amount: -1792,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:21+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'a635d36e-dcc0-4aba-a50d-9fe35a529407',
            name: 'Woodlands Markets',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6a064da5-23f1-4c9a-a073-74a5731e7f52',
        name: 'MISFITS MARKET',
        amount: -9745,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:15+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '03e796b6-2432-46b4-8f3d-428db08afdd1',
            name: 'Misfits Market',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '85c1335a-5f59-4649-af60-cca8363a5522',
        name: 'ATHLETA, INC. NET PAY PPD ID: 3941697231',
        amount: 297034,
        date: '2024-02-14',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '52ecc268-7869-49d6-a266-fc38eb71c7ac',
        merchant: {
            id: '4dfb19c2-3c96-49c4-9de5-fefb4a2976b6',
            name: 'Payroll',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: 'becef62e-59c6-403f-94f1-2211e0a89107',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8d9d0eec-468f-4cfe-bf10-2c7579fa78d2',
        name: 'Amazon',
        amount: -2905,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:16+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a8569857-dd30-488b-8f5e-5c64294b9f52',
        name: 'Old Navy',
        amount: -150,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:14+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: 'b63c84a2-eea1-4661-bdbb-665e7835e244',
            name: 'Old Navy',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/old_navy_698.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a9d04004-5cd3-4228-ab7b-cb147ecea6f0',
        name: 'Amazon',
        amount: -826,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:13+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c5c4c491-29c3-4c42-bb6b-11db784e9cd7',
        name: 'COLE HARDWARE',
        amount: -540,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:12+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '087ba921-22a6-4f08-a690-5d5965e8ad31',
        merchant: {
            id: '09ec5462-8b89-4fd5-87df-b8e28db88107',
            name: 'Cole Hardware',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd18dab60-b19d-4b38-982c-b5e396d7582c',
        name: 'WWW.SWEETGREEN.COM',
        amount: -1501,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:09+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '136f0dba-f10d-4db0-bcce-a76ff7da5dab',
            name: 'Sweetgreen',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/sweetgreen_986.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e040d935-e5c8-4e2c-9b99-9027bae1af1d',
        name: 'SAINT FRANK COFFEE',
        amount: -516,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:17+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: 'd16a5651-84ce-4596-82ce-90a28ddb9e50',
            name: 'Saint Frank Coffee',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ebc7cfd0-b5c6-48f3-9e34-1dd2a2bb90a1',
        name: 'NYTimes*NYTimes',
        amount: -2000,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:19+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '9d9c2725-41fe-4623-9b6c-7f9e29b4606e',
        merchant: {
            id: 'ecd8e745-4ce3-4542-9dd6-4569a5906fe1',
            name: 'New York Times',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/new_york_times_677.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f4b89701-9c15-4511-baaa-8b5f73c2c2b0',
        name: 'VZWRLSS*APOCC VISW',
        amount: -15894,
        date: '2024-02-14',
        dateTime: '2024-02-14T18:05:23+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'cf4709af-fcea-4099-9eab-230d08323c0b',
        merchant: {
            id: '2094bf3a-8332-4a9d-989d-36ad03684818',
            name: 'Verizon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/verizon_1086.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '24a6a963-64e7-4598-812b-7be96799524e',
        name: 'WF CHIRO, INC.',
        amount: -7800,
        date: '2024-02-13',
        dateTime: '2024-02-13T18:06:04+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '80425c56-dd6d-4762-b140-46c1a8cf713e',
        merchant: {
            id: 'ba084070-84f5-460c-8311-0a4a3fa5a895',
            name: 'Waltz Family Chiropractic',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '389c66ca-5526-408c-b2e5-f62c2192a432',
        name: 'SOMA',
        amount: -2756,
        date: '2024-02-13',
        dateTime: '2024-02-13T18:06:06+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: '7148c31a-692b-4893-ad4c-1a9b019a384b',
            name: 'Soma',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f707d8ed-dffa-4faf-9e8e-fdef39cda1fc',
        name: 'SP BELLAVITA',
        amount: -2867,
        date: '2024-02-13',
        dateTime: '2024-02-13T18:06:07+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: 'f45d5aee-714e-48af-bbf4-f4dd2d176d3d',
            name: 'Bellavita',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f90b880e-4f14-4b45-a9f4-53df1bbac52c',
        name: 'Amazon',
        amount: -2159,
        date: '2024-02-13',
        dateTime: '2024-02-13T18:06:05+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0cc3df89-12a4-4dda-b86e-7861c68b8f3f',
        name: 'CCI*CARE.COM',
        amount: -8997,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a78521de-510c-4b67-9271-c0a294a2a6f4',
        merchant: {
            id: '63ea262f-5b90-4e94-af7e-3d5c3ef4dd75',
            name: 'CCI',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '1cfb107d-e11f-4a68-a9b1-c4714e11626f',
        name: 'COLE HARDWARE',
        amount: -2700,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '087ba921-22a6-4f08-a690-5d5965e8ad31',
        merchant: {
            id: '09ec5462-8b89-4fd5-87df-b8e28db88107',
            name: 'Cole Hardware',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '58a2883f-0698-4fd8-be30-8005d06c740e',
        name: 'TST* ARMISTICE BREWING CO',
        amount: -1959,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'f91c87ca-3ee5-4d43-8236-408ce5324f01',
            name: 'Armistice Brewing Co',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '67abafcf-b0d2-4c51-a150-99f384f7efb9',
        name: 'Zelle payment to Alise JPM99a9b3igj',
        amount: -2500,
        date: '2024-02-12',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
        merchant: null,
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6826a14e-e966-4f2e-9865-2c9ba454b085',
        name: 'PAYPAL INST XFER GOOGLE GOOGLE S WEB ID: PAYPALSI77',
        amount: -199,
        date: '2024-02-12',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: null,
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '72e58aaf-13e4-478a-bbb1-995a444d72d8',
        name: 'POT PIE PARADISE & DE',
        amount: -1800,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'd7c7e4c3-aaea-4e9b-b560-e19ef54274cd',
            name: 'Pot Pie Paradise & De',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '9e93ca70-7e1d-431d-8116-b3205ab46262',
        name: 'UNLIMITED COMPANY LLC',
        amount: -400,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: 'e87726b2-77b4-4f84-91d2-921586b3ad0e',
            name: 'Unlimited Company LLC',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '9f2b17a9-f29d-410d-bab3-91c06bb60841',
        name: 'Amazon.com*RB6VB57T2',
        amount: -8067,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ba0dc3cf-0b41-45f6-9b51-44f3277e73a4',
        name: 'CKE*BAKESALE BETTY 5098',
        amount: -1951,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '0b263d4c-019a-462d-a1cd-8ee715dbf2c2',
            name: 'Bakesale Betty',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'bd8586be-f288-4d3f-b27b-93b9f71f9e04',
        name: 'Uber',
        amount: -3470,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '44395cad-1f92-4a23-93eb-89862e433b55',
        merchant: {
            id: '1cc95ebd-332c-4dc8-9915-7fb02dab03e3',
            name: 'Uber',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/uber_1060.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd9eba15b-6e29-45c2-accf-e426564f2902',
        name: 'STARTER BAKERY',
        amount: -1150,
        date: '2024-02-12',
        dateTime: '2024-02-12T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'c20bd624-5df6-4393-96f1-f71a738bd6ae',
            name: 'Starter Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '34648850-f7d6-4faa-a240-9c987c4b5fa0',
        name: 'TIMELESS COFFEE PIEDM',
        amount: -350,
        date: '2024-02-11',
        dateTime: '2024-02-11T13:23:53+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: '6d47ccba-c840-4949-9a43-c30d91e28fd2',
            name: 'Timeless Coffee Piedm',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '35b6cd83-0434-4852-ba3d-6939904bc213',
        name: 'Chevron',
        amount: -7160,
        date: '2024-02-11',
        dateTime: '2024-02-11T13:23:52+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '75303288-7233-4414-b8bd-c2b1e481914f',
        merchant: {
            id: '0f25393b-1f87-4a60-adb0-af2d089687f9',
            name: 'Chevron',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/chevron_195.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '67a5c09f-eb80-409c-8349-3acd83a237c8',
        name: 'REDFIELD CIDER BAR &',
        amount: -6814,
        date: '2024-02-11',
        dateTime: '2024-02-11T13:23:58+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '5bbf603f-6505-4e70-a7c9-8581684cbcac',
            name: 'Redfield Cider Bar',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8cce337a-a501-4391-8bc0-f387fbecb337',
        name: 'CLIPPER SERVICES',
        amount: -2000,
        date: '2024-02-11',
        dateTime: '2024-02-11T13:23:55+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'f9242742-aeca-4c3f-a7b4-89dd0f2bfe21',
        merchant: {
            id: 'c24df4ea-6fbb-4a2a-a59e-d4025459a71d',
            name: 'Clipper Service',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'cb9548e0-aba2-4e9b-a9f3-d3d3dfe8dc61',
        name: 'HIGHWIRE COFFEE ROAST',
        amount: -1125,
        date: '2024-02-11',
        dateTime: '2024-02-11T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: '1fed88f6-248c-4813-b6e1-e85b2192f45e',
            name: 'Highwire Coffee Roast',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'dbffa355-35d7-4d85-89e9-0fb839c303e0',
        name: 'HIGHWIRE COFFEE ROAST',
        amount: -2975,
        date: '2024-02-11',
        dateTime: '2024-02-11T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: '1fed88f6-248c-4813-b6e1-e85b2192f45e',
            name: 'Highwire Coffee Roast',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e8e678f9-bdd9-47fb-953a-eda272435b29',
        name: 'MARKET HALL BAKERY',
        amount: -1500,
        date: '2024-02-11',
        dateTime: '2024-02-11T13:23:56+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'eff8ee0e-8267-4ae1-af15-27ab37355d43',
        name: 'Uber',
        amount: -871,
        date: '2024-02-11',
        dateTime: '2024-02-11T13:23:57+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '44395cad-1f92-4a23-93eb-89862e433b55',
        merchant: {
            id: '1cc95ebd-332c-4dc8-9915-7fb02dab03e3',
            name: 'Uber',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/uber_1060.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f262e0ad-b82c-4c72-bb2e-d0096c222c07',
        name: 'MARKET HALL BAKERY',
        amount: -1571,
        date: '2024-02-11',
        dateTime: '2024-02-11T13:23:59+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '07bfb949-4d11-4502-80f2-7dbf5d11e50a',
        name: 'HIGHWIRE COFFEE ROAST',
        amount: -1925,
        date: '2024-02-09',
        dateTime: '2024-02-09T16:49:32+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: '1fed88f6-248c-4813-b6e1-e85b2192f45e',
            name: 'Highwire Coffee Roast',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a49ad042-8714-41ff-80df-a181e4fa182a',
        name: 'MARKET HALL PRODUCE',
        amount: -2567,
        date: '2024-02-09',
        dateTime: '2024-02-09T16:49:34+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd430ade4-a184-4b1e-b810-ca61e0995912',
        name: 'CLIPPER SERVICES',
        amount: -3000,
        date: '2024-02-09',
        dateTime: '2024-02-09T16:49:33+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'f9242742-aeca-4c3f-a7b4-89dd0f2bfe21',
        merchant: {
            id: 'c24df4ea-6fbb-4a2a-a59e-d4025459a71d',
            name: 'Clipper Service',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8c8cad78-28a4-4b40-bc02-e3dad49c0f80',
        name: "Trader Joe's",
        amount: -2862,
        date: '2024-02-08',
        dateTime: '2024-02-08T18:05:10+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'dad836a8-06ad-429d-9063-a840d2c85505',
            name: "Trader Joe's",
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/trader_joes_1041.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'b4a28ca3-a242-4873-bab5-998b5cafe3a4',
        name: 'PAYPAL INST XFER APPLE.COM BILL WEB ID: PAYPALSI77',
        amount: -199,
        date: '2024-02-08',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '323f28a1-755d-479d-9fc6-96731b7d339a',
            name: 'Apple',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/apple_63.png',
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd26fb49e-7cf4-4679-913a-fb057c1fb1d2',
        name: 'INTEREST PAYMENT',
        amount: 9,
        date: '2024-02-08',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a68f44ca-cd4c-4d1c-8b3c-e80f04f23410',
        merchant: {
            id: 'cece3ed5-015e-461e-a45e-8755b68b679e',
            name: 'Chase',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '35c40c98-e790-4ab5-8ab1-a9291fe12112',
        name: 'OAKLAND ZOO',
        amount: 6000,
        date: '2024-02-07',
        dateTime: '2024-02-07T16:39:35+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: '5131bbe0-1937-4db2-8f09-79b14b847901',
            name: 'Oakland Zoo',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '04c76aaf-c3d1-4ac0-9130-911086e0ac9c',
        name: "TST* ARTHUR MAC'S LITTLE",
        amount: -4047,
        date: '2024-02-06',
        dateTime: '2024-02-06T16:39:59+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '010461c5-c32b-41e1-9ad7-aabee5214091',
            name: "Arthur Mac's Little",
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '62d68a77-6ded-4c6a-8cb6-3c89fd5b54da',
        name: 'TST* PROPER FOOD - 655',
        amount: -1743,
        date: '2024-02-06',
        dateTime: '2024-02-06T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'a67dcf87-1f0a-4251-8145-8cfe33edb859',
            name: 'Proper Food',
            logoUrl: '',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '89eb9b3d-1b79-4240-bcab-7893bafc6f86',
        name: 'PARKSMART-BAYST',
        amount: -750,
        date: '2024-02-06',
        dateTime: '2024-02-06T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '305064e5-fcb0-442f-a0d1-8c3a5b1f518d',
        merchant: {
            id: '97363338-9c99-4022-a815-b20e62e79dcb',
            name: 'Parksmart',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '93456f6d-16cd-4547-b135-df036785fd7b',
        name: 'FISHER BREW',
        amount: -465,
        date: '2024-02-06',
        dateTime: '2024-02-06T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: 'b5cb8298-ca53-489c-9b54-1ed3dee9662f',
            name: 'Fisher Brew',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'bacba0ee-f8f7-447f-8cc9-5481842723f8',
        name: 'PELOTON* MEMBERSHIP',
        amount: -4400,
        date: '2024-02-06',
        dateTime: '2024-02-06T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '47dcb5ea-bf36-4340-99e5-2e59adf42ff2',
        merchant: {
            id: 'b88a21a9-5018-4820-ad8e-c668a0178dc5',
            name: 'Peloton',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/peloton_739.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'dff73dc4-5f64-4d1e-bbfc-43322e860c2e',
        name: 'GAP 2 FOLSOM',
        amount: -1300,
        date: '2024-02-06',
        dateTime: '2024-02-06T00:00:00+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: '32a7e324-810d-4ce3-b5cb-2544ac7bbd14',
            name: 'Gap',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/gap_421.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e0197c46-907e-410d-86c7-5f8879e27e99',
        name: 'PAYPAL INST XFER JILL.FARACLAS WEB ID: PAYPALSI77',
        amount: -2200,
        date: '2024-02-06',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
        merchant: {
            id: '2a16f89d-6ae6-480c-8c08-0300558d1db9',
            name: 'Jill.faraclas',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ffb7704f-8191-4ef3-99f0-e4442c322746',
        name: 'PERSHING BROKERAGE PPD ID: 1132741729',
        amount: -20000,
        date: '2024-02-06',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
        merchant: {
            id: '1e414ac7-e9c9-4a39-a04c-950bc60342e1',
            name: 'Pershing',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0c09897c-ab63-4ddc-9f9e-88d95096f8f7',
        name: 'TST* GILMAN BREWING - BER',
        amount: -3913,
        date: '2024-02-05',
        dateTime: '2024-02-05T16:41:38+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '6697b7ec-0efe-4889-96fe-58893a09d1e2',
            name: 'Gilman Brewing',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '447de286-9bfd-45c8-9140-6e4490a84566',
        name: 'SCHWAB BROKERAGE MONEYLINK 558622436061170 WEB ID: 9005586224',
        amount: -250000,
        date: '2024-02-05',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a36c0d9c-18cb-450c-8ba2-6d1163cb7fb2',
        merchant: {
            id: '10aa3f0b-dca7-499c-9f2b-152ad0ccc59f',
            name: 'Schwab',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '4e441634-c3f2-4822-942e-de1661d8d588',
        name: 'MARKET HALL PRODUCE',
        amount: -2716,
        date: '2024-02-05',
        dateTime: '2024-02-05T16:41:37+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5e5676dd-4c5f-4e26-9a59-3c90f57149d6',
        name: 'TST* GILMAN BREWING - BER',
        amount: -2459,
        date: '2024-02-05',
        dateTime: '2024-02-05T16:41:39+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '6697b7ec-0efe-4889-96fe-58893a09d1e2',
            name: 'Gilman Brewing',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '990abe24-6264-49c0-b5f8-b66785eb4237',
        name: 'OAKLAND PARK METER IPS OAKLAND CA 02/03',
        amount: -125,
        date: '2024-02-05',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '305064e5-fcb0-442f-a0d1-8c3a5b1f518d',
        merchant: {
            id: 'b860c95f-feea-45d3-8ecc-502ee8d42b52',
            name: 'Oakland Park Meter Ips',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'caa1648a-11b0-43dc-a049-9ae00770e9cd',
        name: 'Plenty Goal Deposit',
        amount: 20000,
        date: '2024-02-01',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '8fdb2f06-a1f0-4f77-90c1-9be3287913a2',
        merchant: {
            id: '9a7435ba-1f7a-41e3-ace7-87ab48a83587',
            name: 'Plenty',
            logoUrl:
                'https://mnv45gni8p6522bf.public.blob.vercel-storage.com/plenty_logo_square-u76akmIb2ewPDSSraiXO3Y4XSFWUWS.png',
            __typename: 'Merchant',
        },
        financialEntityId: 'eca91587-d12b-4091-9d11-3f03ee2f17d7',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f2acbea3-cef3-45a9-9d1f-af73eef2cc6d',
        name: 'HM.COM',
        amount: 1432,
        date: '2024-02-05',
        dateTime: '2024-02-05T16:41:40+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: 'a21475b0-25aa-488a-b295-7d84fe1ca33e',
            name: 'H&M',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/hm_467.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f3357331-ea8f-427b-bba6-4b2c61fe1334',
        name: 'PAYPAL INST XFER APPLE.COM BILL WEB ID: PAYPALSI77',
        amount: -199,
        date: '2024-02-05',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '323f28a1-755d-479d-9fc6-96731b7d339a',
            name: 'Apple',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/apple_63.png',
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '151dce64-be21-4387-a114-0597a1d4f2f4',
        name: 'MARKET HALL FOODS - O',
        amount: -1600,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:38+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '157a250a-a766-464e-8d27-22ed99195ad9',
        name: 'TST* STARTER BAKER',
        amount: -862,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:35+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'd202a87b-9b6e-4b7f-9a0e-9a8a03e4d387',
            name: 'Starter Baker',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '42aac9ed-8d94-47ac-adbb-038c26985e03',
        name: 'KHRUANGBIN-THU PMG',
        amount: -17840,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:41+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '3f717dfa-908e-4b03-b8bc-78997ae09df7',
        merchant: {
            id: '976c8c01-7fb0-43f3-a519-631036f74cd3',
            name: 'Khruangbin-thu',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '476313dc-3198-4675-8878-12e0ee8336ce',
        name: 'EB HABITOT CHILDRENS',
        amount: -1655,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:29+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '511d613b-df12-4918-b57d-addd882b1721',
        merchant: {
            id: '64de78b9-3bdd-4f96-bc8e-a746998cc3de',
            name: 'Eb Habitot Childrens',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '513a1b4e-2270-4f56-a11e-3876043af0b8',
        name: 'TST* TWO PITCHERS BREWING',
        amount: -2197,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:27+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'f13bdb8a-7d8b-4026-a766-d53fae2a73e7',
            name: 'Two Pitchers Brewing',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '528b2750-5741-4f97-a536-b6550f187f71',
        name: 'TST* STARTER BAKER',
        amount: -1525,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:34+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'd202a87b-9b6e-4b7f-9a0e-9a8a03e4d387',
            name: 'Starter Baker',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5a0b3485-1eed-4eca-87cf-8b1830d3225b',
        name: 'SQUARESPACE INC.',
        amount: -1400,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:40+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'a78521de-510c-4b67-9271-c0a294a2a6f4',
        merchant: {
            id: '0c48b404-11e8-4290-a503-978f1c2492a2',
            name: 'Squarespace',
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/squarespace_953.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '60a530b3-b059-485e-9a0a-092b8a7d9593',
        name: "Trader Joe's",
        amount: -2728,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:26+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'dad836a8-06ad-429d-9063-a840d2c85505',
            name: "Trader Joe's",
            logoUrl:
                'https://plaid-merchant-logos.plaid.com/trader_joes_1041.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6ff11c30-5cce-4982-9cbd-dea0d386a4e0',
        name: 'SP OAKTOWN SPICE SHO',
        amount: -3350,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:44+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '7b2747a2-f815-4ce0-a1db-a7b47b97800b',
            name: 'Oaktown Spice Sho',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '814a66fc-cc11-4377-99a2-f93a40c6c037',
        name: 'CLIPPER SERVICES',
        amount: -2000,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:25+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'f9242742-aeca-4c3f-a7b4-89dd0f2bfe21',
        merchant: {
            id: 'c24df4ea-6fbb-4a2a-a59e-d4025459a71d',
            name: 'Clipper Service',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8687539e-1ad2-4bcc-b577-bd8ef0a8f8d7',
        name: 'MARIN SUN FARMS INC.',
        amount: -2818,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:30+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: '843508e8-c23d-4306-9ecb-dfde7770af0e',
            name: 'Marin Sun Farms Inc.',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '8b42f657-c61a-4694-8243-a728a548a410',
        name: 'TST* TWO PITCHERS BREWING',
        amount: -2600,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:32+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'f13bdb8a-7d8b-4026-a766-d53fae2a73e7',
            name: 'Two Pitchers Brewing',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '973868af-560a-4b4f-98b4-383cc285b0a0',
        name: 'SOUVENIR CAFE CLAREMO',
        amount: -1840,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:36+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'ee2040c1-39d9-4fcb-9433-0cc039476a67',
        merchant: {
            id: 'ee85c6ec-4ef2-4e24-9d2d-8ec9aa2d7d39',
            name: 'Souvenir Cafe Claremo',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '987fd6d4-1e26-43f2-a116-6eb2e89a48fb',
        name: "AIN'T NORMAL",
        amount: -1423,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:45+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '542581be-8769-43c3-b2fe-3b1ea39aeda1',
            name: "Ain't Normal",
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a0611aaa-2022-41c2-ab1a-c365c351c9c9',
        name: 'Amazon',
        amount: 9580,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:33+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'bb606b41-4ea0-4a76-ac50-e7f974a0892a',
        name: 'MARKET HALL PRODUCE',
        amount: -2399,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:43+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'bd805352-0584-4f0b-b07c-26bcadac617e',
        merchant: {
            id: 'fb06c245-6645-4e54-bb47-48eeef9dbae3',
            name: 'Market Hall Produce',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f31390bd-142a-4a57-b8e2-55e1c07d32ed',
        name: 'HELP.MAX.COM',
        amount: -1599,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:31+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '8813b8c2-cfa6-4c39-afc5-21d0e9f785ec',
        merchant: {
            id: 'ad2e10b0-22c2-444d-bb76-1e9276abe0fc',
            name: 'HBO Max',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/hbo_max_478.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'fa3f1659-ba2c-452c-912a-04f0d0e1d4fb',
        name: 'MARKET HALL BAKERY',
        amount: -500,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:42+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'fe1877d9-dea0-49ad-8f0c-cbc8e4198ec5',
        name: 'MARKET HALL BAKERY',
        amount: -1150,
        date: '2024-02-04',
        dateTime: '2024-02-04T14:22:28+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'bf1f6557-2afc-4d44-bfe9-4886b213c283',
            name: 'Market Hall Bakery',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '66ecc19e-6a76-4d24-9b08-47654f9f7cff',
        name: 'OPEN INC',
        amount: -15000,
        date: '2024-02-02',
        dateTime: '2024-02-02T18:06:53+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '47dcb5ea-bf36-4340-99e5-2e59adf42ff2',
        merchant: {
            id: '1e3a40ee-0041-48d9-8483-888fb47e7161',
            name: 'Open Inc',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6c11bf81-6ceb-4ecd-a51a-6841dd4ecffe',
        name: 'TST* MENSHO OAKLAND I',
        amount: -3548,
        date: '2024-02-02',
        dateTime: '2024-02-02T18:06:55+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: 'c444f4b7-8103-4eb5-bf98-6274a7c9318b',
            name: 'Mensho',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '7c81f444-7764-44be-a58e-c0be0e15a742',
        name: 'APPLE.COM/BILL',
        amount: -1999,
        date: '2024-02-02',
        dateTime: '2024-02-02T18:06:54+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '323f28a1-755d-479d-9fc6-96731b7d339a',
            name: 'Apple',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/apple_63.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '87ad858b-9ddf-47a9-9330-9841e3c6040c',
        name: 'TST* BELLY - UPTOWN',
        amount: -847,
        date: '2024-02-02',
        dateTime: '2024-02-02T18:06:56+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '4acf3866-5385-4694-9b21-1591366b913f',
            name: 'Belly',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd5eca340-ea66-4125-bc44-d03c226f4266',
        name: 'WF CHIRO, INC.',
        amount: -7800,
        date: '2024-02-02',
        dateTime: '2024-02-02T18:06:57+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '80425c56-dd6d-4762-b140-46c1a8cf713e',
        merchant: {
            id: 'ba084070-84f5-460c-8311-0a4a3fa5a895',
            name: 'Waltz Family Chiropractic',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '13868f33-f8d2-4440-ad4b-f383987aab62',
        name: 'Amazon',
        amount: 8957,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:15+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '56634911-3bda-4f2b-9e43-ae2f3edd0bec',
        name: 'APPLE.COM/BILL',
        amount: -299,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:12+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '323f28a1-755d-479d-9fc6-96731b7d339a',
            name: 'Apple',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/apple_63.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5aa13ff1-fd16-496a-ad37-4071e2508b44',
        name: 'Amazon',
        amount: 2039,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:16+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5d55b89a-6297-4072-b46e-804665198c1a',
        name: 'Amazon',
        amount: 3306,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:08+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '99794697-dedf-4982-8d02-5543e81cfd6d',
        name: 'Amazon.com',
        amount: 2535,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:06+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a170aaf2-3786-41a9-a412-0c5020a82de3',
        name: 'Amazon',
        amount: 1648,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:14+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a785e6ed-31b1-4579-b36b-45c71c1145f1',
        name: 'POPPY BAGELS',
        amount: -2975,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:11+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '8298ffa1-d134-47df-a983-81c36f674445',
            name: 'Poppy Bagels',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'b1f7275f-1579-4af9-974f-d6e603a61372',
        name: 'Amazon',
        amount: 4956,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:13+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'b84f99c7-ac8f-442c-9ace-34f671d81e95',
        name: 'Amazon',
        amount: 1378,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:07+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'bfc6bb6f-14b6-41fb-b52d-c12360bce6d8',
        name: 'Amazon',
        amount: 1432,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:10+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'd8afaeff-5ce5-43fd-a123-5cb82e0e9016',
        name: 'PIEDMONT ECOM 205',
        amount: -3100,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:09+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '75303288-7233-4414-b8bd-c2b1e481914f',
        merchant: {
            id: '9781093f-e97f-4223-a963-0d515bb699a4',
            name: 'Piedmont Ecom',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e05d910e-e720-4f75-93d0-284f13f31344',
        name: 'CHECK # 365',
        amount: -280000,
        date: '2024-02-01',
        dateTime: null,
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '20ad8a59-c5a6-4ca0-b230-2a8223f3ef07',
        merchant: {
            id: '4e5f259e-44e4-4425-81ef-703056175962',
            name: 'Rent',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '2d216f98-52e6-4f81-b978-6c44b8fafcce',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'eaa8aeba-caf9-43f7-8e1b-8d7e3c73c399',
        name: 'Amazon',
        amount: 2856,
        date: '2024-02-01',
        dateTime: '2024-02-01T17:12:17+00:00',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: 'c2db336a-9614-4c58-b5cd-4463dbff881b',
        merchant: {
            id: '91d32e4f-07d8-4328-973b-25852fbb39ea',
            name: 'Amazon',
            logoUrl: 'https://plaid-merchant-logos.plaid.com/amazon_44.png',
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'b5d40507-877e-42d2-9357-546c80628e87',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-01',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5a6e958a-3fd0-4b3a-b880-071bb21f1896',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-02',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '91896e47-3d95-406a-852d-9bfe3bfd1481',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-03',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '1a213f01-bad2-4c7e-a2d4-e7d3e0c019e0',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-04',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'f7d3288c-7c55-4a93-bc8a-95fa32864d0a',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-05',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'a74b74e6-f6c3-4196-bae3-9995b0140958',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-06',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'c6bcb5a9-4182-4225-956e-53c5dc349dc5',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-07',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'e946573f-f176-46c4-b213-2048b16a83db',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-08',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'dbd320eb-5c5c-4a52-8e4a-abb185dffe61',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-09',
        dateTime: '2024-05-07T23:09:41.019Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '7014c2a8-b653-45f8-97f2-f1aeb6bde337',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-10',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ec9b181b-1f14-438a-8bf2-5b9aa3ba9208',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-11',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'ce61f093-87b3-4f47-ae98-357997b28556',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-12',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'adfee833-2366-4a75-94f3-2c5eadb9baf5',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-13',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '35572e00-0752-4e42-884d-092db3544a4b',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-14',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '4df1fd76-bc97-45a0-b21a-c5d6bc324c02',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-15',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '1d188f1e-521d-41c4-9ef5-a371c9c3a328',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-16',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0dfd9bc2-aa9a-4e58-9ed6-92e2b11c11f6',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-17',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '80b61899-69c4-4a01-86aa-bc027b3297ff',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-18',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '6f199014-3988-4841-ad29-6b239c965a8e',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-19',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0dc7edbd-b304-4619-9a2f-2864e0fdbbdf',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-20',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '0133c096-fbfb-4d50-be90-0d706683a9bb',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-21',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '1f933fdd-9e51-4ca6-b965-fcb8854dab5c',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-22',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '9ade7893-c4ce-4c40-8b0f-741550cfe575',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-23',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '412481da-0a81-40e7-9a17-9caced163b9b',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-24',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '9554dbea-948c-4f3b-bf6e-e1cf42bd0b92',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-25',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '5c504652-4b74-4760-93a9-b088d858167e',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-26',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '7c583c75-e491-4c23-a2eb-d1ccc354b9bb',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-27',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '246cd04e-66ed-4b2e-be49-81a091ec7865',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-28',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: '41e6cf4c-24f1-491f-9930-84b6cf75b6d1',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-29',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
    {
        id: 'cb3766e5-c69b-4012-a1d0-cf7f0f622187',
        name: 'MARKET HALL FOODS - O',
        amount: -116500,
        date: '2024-01-30',
        dateTime: '2024-05-07T23:09:41.020Z',
        isPending: false,
        isHidden: false,
        deletedAt: null,
        categoryId: '94fbf65b-6309-4ecb-8e91-182e30334c2d',
        merchant: {
            id: '619e608a-6389-4add-bc75-249cec9fe8e6',
            name: 'Market Hall Foods',
            logoUrl: null,
            __typename: 'Merchant',
        },
        financialEntityId: '5b83bd54-319a-4e26-acb8-5e5aec3ed197',
        __typename: 'TransactionEntry',
        tags: [],
        categorizedByPlenty: false,
    },
];
